var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",staticClass:"outer-rotator",style:({
  animationPlayState: _vm.rotateDur ? 'running' : 'paused',
  animationDuration: (_vm.rotateDur + "ms")
})},[_c('div',{staticClass:"rotate-cont-root",style:({
      width: "0px",
      height: ((_vm.ch * 2) + "px"),
      transformOrigin: 'center',
      transform: ("translate(" + (0) + "px, " + (-_vm.ch) + "px) rotate(" + (_vm.r + _vm.groundX) + "deg)"),
      transition: ("transform " + _vm.dur + "ms 0s " + _vm.easing),
    })},[(_vm.orbitLine)?_c('div',{staticClass:"orbit",style:({
        width: ((_vm.ch * 2) + "px"),
        height: ((_vm.ch * 2) + "px"),
        border: _vm.orbitLine,
        transformOrigin: 'center',
        transform: ("translate(" + (-_vm.ch) + "px, " + (0) + "px)"),
        transition: ("transform " + _vm.dur + "ms 0s " + _vm.easing),
      })}):_vm._e(),_c('e-cont',{attrs:{"s":_vm.s}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }